import {FxxlSideModal} from '@fxxl/side_modal';
import JsonModalController from '@fxxl/json_modal_controller';

export default class JsonSideModal
{
    static tryHandleSideModal(targetObject: HTMLElement, kindName: string)
    {
        const sideModalElement = targetObject.querySelector('.fxxl-side-modal');

        if (sideModalElement) {
            document.body.append(targetObject);
            new FxxlSideModal($(sideModalElement)).openSideModal();
            JsonModalController.notifyModalOpened(kindName, targetObject);
            return true;
        } else {
            return false;
        }
    }
}
